import { StudentField, IStudent } from '@studyportals/studentdomain';
import { StudentClient } from '../infrastructure/student-client';

export class StudentRepository {
	private completenessScope: StudentField[];
	private studentClient: StudentClient = new StudentClient();

	constructor() {
		this.completenessScope = [
			StudentField.STUDY_LEVEL,
			StudentField.STUDY_COUNTRY_ID,
			StudentField.DISCIPLINES,
			StudentField.GPA,
			StudentField.WORK_EXPERIENCE,
			StudentField.PROFICIENCY_TYPE,
			StudentField.TUITION_BUDGET,
			StudentField.LIVING_BUDGET,
		];
	}

	public async getFields(fields: StudentField[]): Promise<IStudent | null> {
		return await this.studentClient.getData(fields);
	}

	public async getCompleteness(): Promise<number> {
		return Math.ceil(
			(await this.studentClient.getCompleteness(this.completenessScope)) * 100,
		);
	}
}
